const DATASOURCEVIEW = {
  listOrigens: "Lista de fontes",
  uploadOrigin: "Fonte de carga",
  conecctions: "Conexões",
  origin: "Fonte",
  description: "Descrição",
  company: "Companhia",
  process: "Processo",
  numberRecords: "Não há registros",
  state: "Doença",
  actions: "Ações",
  emptyOrigins: "Nenhuma fonte de dados registrada",
  listForms: "Lista de formulários",
  deleteOrigin: "Excluir fonte de dados: {description}",
  messagge1: "Esta opção não pode ser desfeita, tem certeza?",
  accept: "Aceitar",
  cancel: "Cancelar",
  titleDeleteOrigen: "Excluir fontes de dados",
  errorToDeleteOrigen: "Ocorreu um erro ao excluir a fonte de dados",
  originData: "Fontes de dados",
  actionNotAvailable: "Ação não disponível no momento",
  uploadFileOriginData: "Carrega um arquivo com informações para a Fonte de Dados.",
  charactersSpecials:
    "Lembre-se de não usar <strong>caracteres especiais nos cabeçalhos, nem deixar espaços em branco.</strong>",
  uploadmasive: "upload em massa",
  searchConnection: "Encontrar conexão...",
  connections: "Conexões",
  dataBase: "Base de dados",
  dataBaseNotHasTabe: "O banco de dados não possui tabelas.",
  Create: "Para criar",
  originData: "Origem dos dados",
  errorToCreateOrigin: "Erro ao criar a fonte de dados.",
  successCreate: "Fonte de dados criada",
  btnCreateOrigin: "Criar fonte"
};

export default { DATASOURCEVIEW };
